import * as React from "react";
import { useAuth } from "AuthContext";
import { LoginUrl, ApplicationId } from "config/appUrlConfig";

function RequireAuth({ children }: { children: JSX.Element }) {
	let auth = useAuth();

	if (!auth.user) {
		// Redirect them to the /login page
		window.location.href = LoginUrl + "?next=" + ApplicationId;;
	}

	return children;
}

export default RequireAuth;